module.exports = __webpack_public_path__ + "img/answer-nolist.ba4bed19.png";